import Component from 'flarum/common/Component';
import m from 'mithril';
import { isLocked, isDiscussionPath, syncGuestBodyClass, showGuestNotice, consumeGuestNoticeFlag, diagEnabled, diagInfo } from '../utils/guestGuard';

/*
 * 游客内容守卫（挂载根组件，自身不渲染任何可见 UI）。
 *
 * 做三件事：
 *
 * 1) 点击拦截（capture 阶段）
 *    讨论列表里的标题是 <a href="/d/12">，mithril 的 Link 组件会做 SPA 跳转。
 *    在 document 的 capture 阶段抢先处理：命中帖子地址时 preventDefault +
 *    stopPropagation，mithril 的 onclick 就不会执行，页面**原地不动**，只弹提示窗。
 *
 * 2) 定时同步登录态标记
 *    body.AcmeGuest 决定 CSS 是否隐藏正文摘要。游客先进站、之后在站内
 *    （微信自动登录 / 短信登录）完成登录时，标记必须及时摘掉，
 *    否则已登录用户会「只看得到标题、看不到正文」。
 *
 * 3) 诊断（地址栏加 ?guest=diag）
 *    页面顶部显示当前判定：是否游客、用户 id、开关状态、body 标记、当前路由。
 *
 * 帖子详情页本身由 components/DiscussionLock.js 接管（1.7.0 起不再整页跳转）。
 */
export default class GuestGuard extends Component {
  oncreate(vnode) {
    super.oncreate(vnode);

    // capture = true：必须抢在 mithril 的 Link onclick 之前执行
    this.clickHandler = (e) => this.onClickCapture(e);
    document.addEventListener('click', this.clickHandler, true);

    syncGuestBodyClass();

    // 登录 / 登出后及时更新标记；诊断模式下顺便刷新诊断条
    this.syncTimer = setInterval(() => {
      syncGuestBodyClass();
      if (diagEnabled()) m.redraw();
    }, 600);

    // 兼容 1.6.x 遗留的 ?guestNotice=1（老页面缓存 / 旧链接）
    if (consumeGuestNoticeFlag()) {
      setTimeout(() => showGuestNotice(), 400);
    }
  }

  onremove(vnode) {
    super.onremove(vnode);

    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler, true);
      this.clickHandler = null;
    }

    if (this.syncTimer) {
      clearInterval(this.syncTimer);
      this.syncTimer = null;
    }

    try {
      document.body.classList.remove('AcmeGuest');
    } catch (e) {
      // ignore
    }
  }

  onClickCapture(e) {
    // 每次点击都先同步一次：刚登录完的第一次点击不会被误判成游客
    syncGuestBodyClass();

    if (!isLocked()) return;

    const target = e.target;
    const link = target && target.closest ? target.closest('a') : null;
    if (!link) return;

    let href = '';
    try {
      href = link.getAttribute('href') || '';
    } catch (e2) {
      return;
    }

    if (!isDiscussionPath(href)) return;

    // 阻止 mithril SPA 跳转 + 原生跳转：页面原地不动，只弹提示窗
    e.preventDefault();
    e.stopPropagation();

    showGuestNotice();
  }

  view() {
    syncGuestBodyClass();

    if (!diagEnabled()) return null;

    const d = diagInfo();

    return (
      <div className="AcmeGuestDiag">
        <b>游客守卫诊断</b>
        {'：'}
        {d.locked ? '已锁定' : '未锁定'}
        {'｜游客：'}
        {d.isGuest ? '是' : '否'}
        {'｜用户ID：'}
        {String(d.userId)}
        {'｜开关：'}
        {d.enabled ? '开' : '关'}
        {'｜body.AcmeGuest：'}
        {d.bodyClass ? '有' : '无'}
        {'｜路由：'}
        {d.path || '/'}
      </div>
    );
  }
}
